export default __webpack_public_path__ + "static/PromptIconFour-c2ef2e6a0f193de9ba5cd2c17cf2fcd3.png";